import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useUserResources = (userId: string | undefined) => {
  const ativosQuery = useQuery({
    queryKey: ['user-ativos', userId],
    queryFn: async () => {
      if (!userId) return [];
      const { data, error } = await supabase
        .from('cmdb_ativos')
        .select(`
          id,
          nome,
          patrimonio,
          status_operacional,
          tipo_id,
          modelo,
          numero_serie
        `)
        .eq('proprietario_id', userId)
        .order('nome');
      
      if (error) throw error;
      return data || [];
    },
    enabled: !!userId,
  });

  const licencasQuery = useQuery({
    queryKey: ['user-licencas', userId],
    queryFn: async () => {
      if (!userId) return [];
      const { data, error } = await supabase
        .from('cmdb_software_licencas')
        .select(`
          id,
          chave_licenca,
          status,
          data_expiracao,
          software:cmdb_softwares(
            id,
            nome,
            versao,
            fabricante:fabricantes(nome)
          )
        `)
        .eq('usuario_id', userId)
        .order('criado_em', { ascending: false });
      
      if (error) throw error;
      return data || [];
    },
    enabled: !!userId,
  });

  return {
    ativos: ativosQuery.data || [],
    licencas: licencasQuery.data || [],
    isLoading: ativosQuery.isLoading || licencasQuery.isLoading,
    isError: ativosQuery.isError || licencasQuery.isError,
  };
};
